import axiosClient from '../../api/axiosClient.js';
import { fetchPageData } from '../../api/utils.js';
import AuthService from '../../auth/AuthService';

// Pick the endpoint based on the logged-in user's role. Login is the
// only place that needs the try-instructor-then-fallback pattern,
// because role isn't known yet at that point. Once authenticated,
// AuthService.getUser().is_instructor tells us which endpoint to
// hit directly, avoiding a wasted 403 round-trip for students.
async function getStudentGeneralInfo() {
  const user = AuthService.getUser();
  const url = user?.is_instructor ? `/api/general-info/` : `/api/student/general-info/`;
  const { data } = await axiosClient.get(url);
  return data;
}

export const studentGeneralInfoQuery = () => {
  return {
    queryKey: ['studentGeneralInfo'],
    queryFn: async () => getStudentGeneralInfo(),
    refetchOnWindowFocus: false
  };
};

async function getConsolidatedScores() {
  const { data } = await axiosClient.get(`/api/scores/`);
  return data;
}

export const consolidatedScoresQuery = () => {
  return {
    queryKey: ['consolidatedScores'],
    queryFn: async () => getConsolidatedScores(),
    refetchOnWindowFocus: false
  };
};

async function getTournaments() {
  return fetchPageData(`/api/tournaments/tournaments/`);
}

export const tournamentsQuery = () => {
  return {
    queryKey: ['tournaments'],
    queryFn: async () => getTournaments(),
    refetchOnWindowFocus: false
  };
};

async function getScenarioLevels({scenarioId}) {
  const user = AuthService.getUser();
  const url = user?.is_instructor
    ? `/api/games/instructor/scenario-levels/?scenarios=${scenarioId}`
    : `/api/games/scenario-levels/?scenarios=${scenarioId}`;
  return fetchPageData(url);
}

export const scenarioLevelsQuery = ({scenarioId}) => {
  return {
    queryKey: ['assignmentScenarioLevels', scenarioId],
    queryFn: async () => getScenarioLevels({scenarioId}),
    refetchOnWindowFocus: false,
    enabled: !!scenarioId
  };
};
